export const LOANS_ARCHIVE_ROUTE_PATH = 'archive';
export const LOANS_ARCHIVE_URL = '/loans/archive';

/** Where a restored Loan is opened: its terms page. */
export const getLoanTermsUrl = (id: number | string): string => `/loans/terms/${id}`;
